var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"stepper"},_vm._l((_vm.item),function(step,index){return _c('div',{key:index,class:{ step: true, active: step.active }},[_vm._v(" "+_vm._s(step.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }